import { BottomNavigation, BottomNavigationAction, Box } from "@mui/material";
import React from "react";
import useTranslation from "../../hooks/useTranslation";
import authStore from "../../stores/AuthStore";
import { UserRoles } from "../../stores/AuthStore/types";
import { useNavigate } from "react-router-dom";
import caseStore from "../../stores/CaseStore";
import configStore from "../../stores/ConfigStore";
import { CaseStatus } from "../../stores/CaseStore/types";
import ReactGA from "react-ga4";

const MobileNav = () => {
  const { t } = useTranslation();
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
  const isLawyer = authStore.userHasRole(UserRoles.LAWYER);
  const isAdmin = authStore.userHasRole(UserRoles.ADMIN);
  const activeCasesCount = caseStore.userCases.filter(
    (caseItem) => caseItem.status !== CaseStatus.COMPLETED
  ).length;

  return (
    <Box sx={{ width: "100%", position: "fixed", bottom: 0, zIndex: "999" }}>
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);

          switch (newValue) {
            case 0:
              navigate("/");
              break;

            case 1:
              isLawyer ? navigate("/delegation/new") : navigate("/case/new");
              ReactGA.event({
                category: "User Interaction",
                action: "New Case Click",
                label: "New Case Mobile",
              });
              break;

            case 2:
              navigate("/profile");
          }
        }}
      >
        <BottomNavigationAction
          label={t("homepage")}
          icon={<i className="fal fa-home" />}
        />
        {!isAdmin && activeCasesCount < configStore.appConfig.caseLimit && (
          <BottomNavigationAction
            label={isLawyer ? t("new-delegation") : t("new-case")}
            icon={<i className="fal fa-plus" />}
          />
        )}
        <BottomNavigationAction
          label={t("profile")}
          icon={<i className="fal fa-user" />}
        />
      </BottomNavigation>
    </Box>
  );
};

export default MobileNav;
